import React, { useCallback, useRef } from 'react'

export default function PlayersSearch({onQuery}) {
  const timer = useRef()

  const onChangeQuery = (value) => {
    clearTimeout(timer.current)
    timer.current = setTimeout(()=> onQuery(value), 500)
  }

  return <div className='form-group has-feedback has-search'>
    <span className='form-control-feedback'/>
    <input 
      className='reservation-player-search form-control' 
      placeholder='Search for players'
      onChange={e => onChangeQuery(e.target.value)}
    />
  </div>
}
